import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { authManager } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';
import { Suspense } from 'react';

import { useNotifications } from 'hooks/useNotifications';

import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading/knowledgeLoading';
import { RemoteKnowledgeDeliveryRoutes } from './components/remotes';

export const KnowledgeDeliveryRoutes = (): JSX.Element => {
  const notify = useNotifications();
  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <Suspense fallback={<KnowledgeLoading />}>
        <RemoteKnowledgeDeliveryRoutes
          getLock={async () => await authManager.getAuthData()}
          notify={notify}
          environment={config.environment}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
